export const NEW_PAGE_SET = 'NewPageSet';
